import React from 'react';

interface ContactTableSkeletonProps {
  rows?: number;
}

const ContactTableSkeleton: React.FC<ContactTableSkeletonProps> = ({
  rows = 10,
}) => {
  return (
    <div className="bg-white rounded-lg shadow">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50">
            <tr>
              <th className="w-12 px-6 py-3 text-left">
                <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
              </th>
              <th className="px-6 py-3 text-left min-w-[200px]">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
              </th>
              <th className="px-6 py-3 text-left min-w-[120px]">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
              </th>
              <th className="px-6 py-3 text-left min-w-[120px]">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
              </th>
              <th className="px-6 py-3 text-left min-w-[120px]">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
              </th>
              <th className="px-6 py-3 text-left min-w-[120px]">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
              </th>
              <th className="px-6 py-3 text-left min-w-[140px]">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
              </th>
              <th className="px-6 py-3 text-left w-20">
                <div className="h-4 bg-gray-200 rounded animate-pulse w-16"></div>
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {Array.from({ length: rows }).map((_, index) => (
              <tr key={index} className="hover:bg-gray-50">
                <td className="w-12 px-6 py-4">
                  <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap min-w-[200px]">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-40"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap min-w-[120px]">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap min-w-[120px]">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap min-w-[120px]">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-20"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap min-w-[120px]">
                  <div className="h-4 bg-gray-200 rounded animate-pulse w-24"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap min-w-[140px]">
                  <div className="h-5 bg-gray-200 rounded-full animate-pulse w-20"></div>
                </td>
                <td className="px-6 py-4 whitespace-nowrap w-20">
                  <div className="flex items-center gap-2">
                    <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                    <div className="w-4 h-4 bg-gray-200 rounded animate-pulse"></div>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default ContactTableSkeleton;
